const privacyEffectiveDate =
    process.env
        .NEXT_PUBLIC_PRIVACY_EFFECTIVE_DATE ||
    "2026-10-14";

const formatPrivacyEffectiveDateHu = (
    value
) => {
    const [
        year,
        month,
        day,
    ] = value.split("-");

    const months = [
        "január",
        "február",
        "március",
        "április",
        "május",
        "június",
        "július",
        "augusztus",
        "szeptember",
        "október",
        "november",
        "december",
    ];

    return `${year}. ${
        months[
            Number(month) - 1
        ]
    } ${Number(day)}.`;
};

const privacyEffectiveDateHu =
    formatPrivacyEffectiveDateHu(
        privacyEffectiveDate
    );

const privacyContentHu = {
    pageTitle:
        "adatkezelési tájékoztató",

    introduction:
        "tájékoztatás a személyes adatok kezeléséről és védelméről.",

    documentName:
        "Adatkezelési tájékoztató",

    effectiveDate:
        `hatályos: ${privacyEffectiveDateHu} napjától`,

    translationNotice:
        null,

    tableHeaders: [
        "Név",
        "Típus",
        "Cél",
        "Időtartam",
    ],

    sections: [
        {
            id:
                "data-controller",

            title:
                "Az adatkezelő",

            entries: [
                "A strike.hu weboldal és a STRIKE Urban Playground szolgáltatásai keretében végzett adatkezelések adatkezelője:",

                {
                    type:
                        "details",

                    items: [
                        "Ötlet Outlet Kft.",
                        "Székhely: 1136 Budapest, Tátra utca 5/A. 1. em. 2.",
                        "Cégjegyzékszám: 01-09-436287",
                        "Adószám: 27510478-2-41",
                        "Képviselő: Nyári Zsolt ügyvezető",
                        "E-mail: info@strike.hu",
                        "Telefon: +36 30 120 2326",
                        "Weboldal: strike.hu",
                    ],
                },

                "A szolgáltatás helyszíne:",

                {
                    type:
                        "details",

                    items: [
                        "STRIKE Urban Playground",
                        "1136 Budapest, Pannónia utca 46/A.",
                    ],
                },

                "A továbbiakban: Adatkezelő vagy STRIKE.",
            ],
        },
        {
            id:
                "scope-and-principles",

            title:
                "A tájékoztató hatálya és alapelvek",

            entries: [
                "Jelen tájékoztató a strike.hu weboldal látogatóira, a regisztrált felhasználókra, a vásárlókra, a kapcsolattartókra, a hírlevélre feliratkozókra, valamint a STRIKE helyszínét látogató személyekre vonatkozik.",
                "Az Adatkezelő a személyes adatokat jogszerűen, tisztességesen és átlátható módon, meghatározott célból, a szükséges mértékben és ideig kezeli. Az Adatkezelő megfelelő technikai és szervezési intézkedésekkel védi az adatokat a jogosulatlan hozzáféréstől, megváltoztatástól, továbbítástól, nyilvánosságra hozataltól, törléstől és megsemmisüléstől.",
            ],
        },
        {
            id:
                "registration",

            title:
                "Regisztráció és felhasználói fiók",

            entries: [
                {
                    type:
                        "block",

                    title:
                        "Kezelt adatok",

                    paragraphs: [
                        "E-mail-cím, választott felhasználói álnév vagy becenév, a fiók technikai azonosítói, létrehozásának és módosításának időpontja, valamint a fiók biztonságos használatához szükséges technikai adatok.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Az adatkezelés célja",

                    paragraphs: [
                        "A felhasználói fiók létrehozása, azonosítása és működtetése, a bejelentkezés biztosítása, valamint a korábbi rendelések és mentett kapcsolattartási, illetve számlázási adatok elérhetővé tétele.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Jogalap",

                    paragraphs: [
                        "A GDPR 6. cikk (1) bekezdés b) pontja szerinti szerződés teljesítése, illetve a felhasználó kérésére a szerződés megkötését megelőző lépések megtétele.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Megőrzési idő",

                    paragraphs: [
                        "A fiók törléséig, de legfeljebb az utolsó bejelentkezéstől vagy érdemi fiókművelettől számított 5 évig. Az Adatkezelő az inaktivitási idő lejárta előtt értesítést küldhet. A felhasználó a fiókot a beállításokban bármikor törölheti.",
                        "A fiók törlése nem érinti azokat a rendelési, számlázási vagy jogi igényhez szükséges adatokat, amelyek megőrzését jogszabály írja elő vagy más jogalap teszi szükségessé.",
                    ],
                },
            ],
        },
        {
            id:
                "booking-and-orders",

            title:
                "Foglalás, rendelés és jegyvásárlás",

            entries: [
                {
                    type:
                        "block",

                    title:
                        "Kezelt adatok",

                    paragraphs: [
                        "Kapcsolattartó neve, e-mail-címe és telefonszáma, a foglalás napja, kezdési és befejezési időpontja, létszáma, a megrendelt termék vagy szolgáltatás, rendelési azonosító, árak, díjak, fizetési állapot, elektronikus jegy és QR-kód, továbbá az alkalmazott kupon- vagy kedvezménykód, az ajándékkártya kódja, értéke, érvényessége és felhasználási állapota, amennyiben ezek valamelyike a rendeléshez kapcsolódik, valamint a rendelés teljesítésével kapcsolatos kommunikáció.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Az adatkezelés célja",

                    paragraphs: [
                        "A foglalás és a rendelés létrehozása, a fizetés kezelése, a jegy kiállítása és kézbesítése, a beléptetés, a szolgáltatás teljesítése, az ajándékkártyák és kuponok kiállítása, nyilvántartása, érvényességének ellenőrzése és beváltásának kezelése, a jogosulatlan vagy ismételt felhasználás megelőzése, kapcsolattartás, továbbá a módosítások, panaszok és visszatérítések kezelése.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Jogalap",

                    paragraphs: [
                        "A GDPR 6. cikk (1) bekezdés b) pontja szerinti szerződés teljesítése. A számviteli és adózási kötelezettség alá tartozó adatoknál a GDPR 6. cikk (1) bekezdés c) pontja szerinti jogi kötelezettség teljesítése.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Megőrzési idő",

                    paragraphs: [
                        "A szerződés teljesítésétől számított 5 év, a polgári jogi igények általános elévülési idejéhez igazodva. A számviteli bizonylatokat és az azok alapjául szolgáló adatokat az Adatkezelő 8 évig őrzi meg.",
                    ],
                },
            ],
        },
        {
            id:
                "automatic-form-saving",

            title:
                "Űrlapadatok automatikus mentése és megjegyzése",

            entries: [
                "A rendelési és foglalási folyamat során megadott kapcsolattartási és számlázási adatok a kitöltéssel egyidejűleg, automatikusan a STRIKE szerverére kerülhetnek. Az automatikus mentés célja, hogy oldalfrissítés, megszakadt kapcsolat, technikai hiba vagy a rendelési folyamat későbbi folytatása esetén a már megadott adatokat ne kelljen ismét kitölteni.",
                "Az automatikus mentés regisztrált felhasználó és vendégként vásárló esetében is működhet. Regisztrált felhasználónál az adatok a felhasználói fiókhoz, vendégnél pedig a böngészőben tárolt technikai guestJwt vendégazonosítóhoz kapcsolódnak.",
                {
                    type:
                        "block",

                    title:
                        "Kezelt adatok",

                    paragraphs: [
                        "Kapcsolattartó neve, e-mail-címe, telefonszáma, számlázási név, számlázási cím, adószám, ha annak megadása szükséges, továbbá a foglalási és rendelési űrlapon megadott, a rendelés előkészítéséhez szükséges adatok.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "A folyamatban lévő rendelés automatikus mentése",

                    paragraphs: [
                        "Az adatkezelés célja a rendelési vagy foglalási folyamat működtetése, a megadott adatok elvesztésének megelőzése, valamint annak biztosítása, hogy a felhasználó vagy vendég a megkezdett folyamatot megszakítás után is folytathassa.",
                        "Az adatkezelés jogalapja a GDPR 6. cikk (1) bekezdés b) pontja szerinti szerződés teljesítése, illetve az érintett kérésére a szerződés megkötését megelőző lépések megtétele.",
                        "A be nem fejezett rendeléshez kapcsolódó, automatikusan mentett személyes adatokat az Adatkezelő az utolsó rendelési vagy foglalási művelettől számított legfeljebb 30 napig kezeli, kivéve, ha az adatok hosszabb megőrzésére az alábbiak szerint megfelelő jogalappal rendelkezik.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Adatok automatikus mentése regisztrált felhasználónál",

                    paragraphs: [
                        "A regisztrált felhasználói fiók részeként a rendelési folyamat során megadott kapcsolattartási és számlázási adatok automatikusan mentésre kerülhetnek a felhasználó fiókjába. A mentés célja a felhasználói fiók működtetése, valamint annak biztosítása, hogy a későbbi rendelések során a felhasználónak ne kelljen ismét megadnia ugyanazokat az adatokat.",
                        "A felhasználó a regisztráció előtt tájékoztatást kap arról, hogy a felhasználói fiók a kapcsolattartási és számlázási adatok automatikus mentését és későbbi visszatöltését is biztosítja.",
                        "Az adatkezelés jogalapja a GDPR 6. cikk (1) bekezdés b) pontja szerinti szerződés teljesítése, mivel az automatikus adatmentés a regisztrált felhasználói fiók előre ismertetett és a felhasználó által igénybe vett funkciója.",
                        "A felhasználó a mentett kapcsolattartási és számlázási adatokat a fiókbeállításokban bármikor megtekintheti, módosíthatja vagy törölheti. Az adatok a felhasználó általi törlésig, a fiók törléséig, de legfeljebb az utolsó érdemi fiókművelettől számított 5 évig maradnak meg.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Adatok megjegyzése vendégnél",

                    paragraphs: [
                        "Vendégként indított rendelés esetén a kapcsolattartási és számlázási adatok következő rendeléshez történő megőrzése kizárólag a vendég külön, önkéntes hozzájárulása alapján történik.",
                        "A vendég a rendelési folyamat során megjelenő, alapértelmezetten üres jelölőnégyzettel kérheti, hogy a STRIKE a megadott adatokat a következő rendelés egyszerűbb és gyorsabb kitöltése érdekében megőrizze.",
                        "A vendég hozzájárulásának hiánya nem akadályozza a rendelés vagy foglalás véglegesítését, és nem befolyásolja a STRIKE szolgáltatásainak igénybevételét.",
                        "Vendég esetén a megjegyzett adatok a böngészőben tárolt guestJwt azonosítóhoz kapcsolódnak. Emiatt az adatok ugyanazon böngészőben és eszközön, az azonosító érvényességi ideje alatt tölthetők vissza. Másik böngésző, másik eszköz, a böngésző adatainak törlése vagy a guestJwt lejárata esetén az automatikus visszatöltés nem feltétlenül lehetséges.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "A vendégadatok kényelmi megőrzésének jogalapja és időtartama",

                    paragraphs: [
                        "A vendég kapcsolattartási és számlázási adatainak következő rendeléshez történő megjegyzésének jogalapja a GDPR 6. cikk (1) bekezdés a) pontja szerinti önkéntes hozzájárulás.",
                        "A STRIKE a kényelmi célból megjegyzett vendégadatokat a hozzájárulás visszavonásáig, de legfeljebb 180 napig kezeli.",
                        "A vendég a hozzájárulását bármikor visszavonhatja, és kérheti a mentett adatok törlését a vendégbeállításokban vagy az info@strike.hu e-mail-címen.",
                        "A hozzájárulás visszavonása nem érinti a visszavonást megelőző adatkezelés jogszerűségét. A kényelmi célból mentett adatok törlése nem érinti a teljesített rendeléshez, számlázáshoz, panaszkezeléshez vagy jogi igényhez kapcsolódó, más jogalapon megőrzött adatokat.",
                    ],
                },
            ],
        },
        {
            id:
                "payment-and-invoicing",

            title:
                "Fizetés és számlázás",

            entries: [
                "Az online bankkártyás fizetés a Stripe rendszerén keresztül történik. A STRIKE nem ismeri meg és nem tárolja a teljes bankkártyaszámot, a CVC-kódot vagy más, a fizetési szolgáltató által kezelt teljes kártyaadatot.",
                "Amennyiben a banki átutalásos fizetési mód külön engedélyezés alapján elérhető, az átutalás teljesítésének és a rendeléshez történő hozzárendelésének ellenőrzése érdekében a STRIKE kezelheti az átutaló nevét, bankszámlaszámát, az átutalt összeget, a tranzakció időpontját és a közleményben megadott rendelési vagy foglalási azonosítót.",
                "Az elektronikus számla kiállítása és kézbesítése a Billingo rendszerén keresztül történik.",
                {
                    type:
                        "block",

                    title:
                        "Kezelt adatok",

                    paragraphs: [
                        "Fizetési tranzakció azonosítója, fizetési állapot, összeg, pénznem, rendelési azonosító, számlázási név, cím, e-mail-cím, valamint adószám, ha annak megadása szükséges. Banki átutalás esetén az átutaló neve, bankszámlaszáma, az átutalás időpontja és közleménye is kezelésre kerülhet.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Jogalap és megőrzési idő",

                    paragraphs: [
                        "A fizetésnél a GDPR 6. cikk (1) bekezdés b) pontja szerinti szerződés teljesítése, a számlázásnál a GDPR 6. cikk (1) bekezdés c) pontja szerinti jogi kötelezettség teljesítése. A számviteli bizonylatok megőrzési ideje 8 év.",
                    ],
                },
            ],
        },
        {
            id:
                "contact-and-complaints",

            title:
                "Kapcsolatfelvétel és panaszkezelés",

            entries: [
                "Az érintett a weboldalon található kapcsolatfelvételi űrlapon, az info@strike.hu e-mail-címen, telefonon vagy személyesen léphet kapcsolatba a STRIKE-kal. A telefonhívásokról hangfelvétel nem készül.",
                {
                    type:
                        "block",

                    title:
                        "Kezelt adatok",

                    paragraphs: [
                        "Név, e-mail-cím, telefonszám, az üzenet vagy panasz tartalma, a kapcsolódó rendelési adatok, valamint a válaszadáshoz szükséges egyéb, az érintett által megadott adatok.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Jogalap",

                    paragraphs: [
                        "Ha az érintett maga a szerződő fél vagy saját nevében kíván szerződést kötni, a szükséges kapcsolattartás jogalapja a GDPR 6. cikk (1) bekezdés b) pontja. Cég vagy más szervezet kapcsolattartójánál és egyéb megkeresésnél a megkeresés megválaszolásához és az ügyintézéshez fűződő jogos érdek, a GDPR 6. cikk (1) bekezdés f) pontja a jogalap. Jogszabály alapján kezelendő fogyasztói panasz esetén a GDPR 6. cikk (1) bekezdés c) pontja szerinti jogi kötelezettség.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Megőrzési idő",

                    paragraphs: [
                        "Az egyszerű megkereséseket az ügy lezárásától számított 1 évig, a szerződéshez kapcsolódó levelezést az igények elévüléséig, a jogszabály alapján megőrzendő fogyasztói panaszokat és válaszokat 3 évig őrzi meg az Adatkezelő.",
                    ],
                },
            ],
        },
        {
            id:
                "team-building-contact",

            title:
                "Csapatépítő kapcsolatfelvételi űrlap",

            entries: [
                "A csapatépítő oldalon található űrlap díjmentes érdeklődésre és kapcsolatfelvételre szolgál. Beküldése és az automatikus visszaigazolás nem jelent foglalást vagy fizetési kötelezettséget.",
                {
                    type:
                        "block",

                    title:
                        "Kezelt adatok és az adatszolgáltatás jellege",

                    paragraphs: [
                        "Az űrlapon a cégnév, a kapcsolattartó neve, e-mail-címe és telefonszáma, valamint az 1 és 50 fő közötti tervezett létszám megadása szükséges. A legfeljebb 2000 karakteres üzenet opcionális. Az Adatkezelő kezeli a beküldés időpontját, az űrlap nyelvét, a megkeresés és az e-mailek technikai azonosítóit, a kézbesítési állapotot és a kapcsolódó levelezést is.",
                        "Az űrlap használata önkéntes, az adatmegadást nem jogszabály írja elő. A csillaggal jelölt adatok nélkül az online űrlap nem küldhető be; az info@strike.hu címen is lehet érdeklődni. Az adatok a küldés kezdeményezésekor kerülnek továbbításra, kitöltés közbeni szerveroldali piszkozatmentés nincs. Az üzenetben csak a rendezvény egyeztetéséhez szükséges adatokat kérjük megadni.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Az adatkezelés célja",

                    paragraphs: [
                        "A megkeresés fogadása és megválaszolása, a csapatépítő részleteinek egyeztetése, ajánlat előkészítése, kapcsolattartás e-mailben vagy telefonon. A rendszer belső értesítést és az érdeklődőnek automatikus visszaigazolást küld, amelyek a megadott adatokat és az opcionális üzenetet is tartalmazzák.",
                        "A technikai adatok a kézbesítés ellenőrzését, az ismételt küldés és az automatizált visszaélések megelőzését szolgálják. A beküldés nem jelent hírlevél-feliratkozást, és az adatokat ezen az alapon nem használjuk reklámküldésre.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Jogalap és jogos érdek",

                    paragraphs: [
                        "Cég vagy más szervezet kapcsolattartójánál a jogalap a GDPR 6. cikk (1) bekezdés f) pontja: a STRIKE és a megkereső szervezet jogos érdeke az üzleti megkeresés megválaszolása és a rendezvény egyeztetése.",
                        "Saját nevében szerződni kívánó érdeklődőnél a szükséges előkészítő lépések jogalapja a GDPR 6. cikk (1) bekezdés b) pontja. A visszaélések és az ismételt küldés megelőzésének jogalapja a biztonságos működéshez fűződő jogos érdek, a GDPR 6. cikk (1) bekezdés f) pontja szerint.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Megőrzési idő",

                    paragraphs: [
                        "A foglaláshoz vagy szerződéshez nem vezető megkeresést az ügy lezárásáig, majd legfeljebb 1 évig őrizzük meg, a jelen tájékoztató egyszerű megkeresésekre vonatkozó szabályával összhangban. A lezárás utáni megőrzés célja és jogos érdeke az előzmények visszakereshetősége és az esetleges utókérdések rendezése.",
                        "Ha a megkeresésből foglalás vagy szerződés lesz, a teljesítéséhez szükséges levelezésre a foglalás és rendelés megőrzési szabályai irányadók. Jogvita esetén a szükséges adatokat a jogi igény rendezéséig őrizzük meg. A megőrzési szabályok a levelezés másolataira és a kézbesítési hibák miatt megőrzött technikai példányokra is vonatkoznak.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Hozzáférés és érintetti jogok",

                    paragraphs: [
                        "A megkereséshez a STRIKE ügyintézésben részt vevő munkatársai férnek hozzá. Az informatikai és levelezési infrastruktúrát az adatfeldolgozók között megjelölt Rendszeres Kft. működteti. Az e-mailek a STRIKE levelezőrendszerében, köztük az elküldött levelek között is tárolódnak; a kézbesítési hibák rendezéséhez technikai másolat is megőrizhető.",
                        "A jogos érdeken alapuló adatkezelés ellen saját helyzetével kapcsolatos okból az info@strike.hu címen lehet tiltakozni. A hozzáférés, helyesbítés, törlés, korlátozás és egyéb jogok feltételeit, valamint a panasztétel lehetőségeit az érintetti jogokról és jogorvoslatról szóló fejezetek tartalmazzák.",
                    ],
                },
            ],
        },
        {
            id:
                "newsletter",

            title:
                "Hírlevél és közvetlen üzletszerzés",

            entries: [
                {
                    type:
                        "block",

                    title:
                        "Kezelt adatok",

                    paragraphs: [
                        "E-mail-cím, feliratkozás és hozzájárulás időpontja, technikai igazolási adatok, leiratkozás időpontja, továbbá a kiküldésekhez kapcsolódó kézbesítési adatok.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Az adatkezelés célja és jogalapja",

                    paragraphs: [
                        "Hírek, ajánlatok, események és marketingtartalmak küldése. Az adatkezelés jogalapja az érintett önkéntes hozzájárulása a GDPR 6. cikk (1) bekezdés a) pontja alapján.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Megőrzési idő",

                    paragraphs: [
                        "A hozzájárulás visszavonásáig vagy a leiratkozásig. A leiratkozás minden hírlevélben elérhető, és az info@strike.hu címen is kérhető. A hozzájárulás visszavonása nem érinti a visszavonás előtti adatkezelés jogszerűségét.",
                    ],
                },
            ],
        },
        {
            id:
                "analytics-and-marketing",

            title:
                "Webanalitika, hirdetések és belső mérés",

            entries: [
                "A STRIKE a weboldal használatának elemzéséhez, a felhasználói élmény javításához, a hirdetések és konverziók méréséhez, valamint a saját kampányai eredményességének megállapításához analitikai és marketingcélú adatkezelést végezhet.",
                {
                    type:
                        "block",

                    title:
                        "Kezelt adatok",

                    paragraphs: [
                        "A hivatkozó weboldal URL-je és domainje, UTM source, UTM medium, UTM campaign, UTM id, UTM term és UTM content értékek, technikai vendégazonosító, továbbá a weboldal használatához és a konverziók méréséhez kapcsolódó technikai eseményadatok.",
                        "A biztonsági célból, hozzájárulástól függetlenül kezelt IP-cím, user agent és érkezési idő nem része az analitikai vagy marketingcélú adatkörnek. Ezek kezelését a Technikai, biztonsági és szervernaplók című fejezet tartalmazza.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Saját belső mérési rendszer",

                    paragraphs: [
                        "A STRIKE saját belső mérési rendszere az érkezési forrás és az UTM-kampányparaméterek alapján méri, hogy az egyes kampányokból hány látogatás és vásárlás érkezett.",
                        "A belső mérés során az érkezési és kampányadatok a technikai vendégazonosítóhoz kapcsolódhatnak. Amennyiben a látogató később rendelést ad le, a rendszer megállapíthatja, hogy a vásárlás melyik érkezési forráshoz vagy kampányhoz tartozott.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Külső szolgáltatások",

                    paragraphs: [
                        "A STRIKE Google Analytics, Google Tag Manager, Google Ads, Meta Pixel és Microsoft Clarity szolgáltatásokat használhat a weboldal használatának elemzésére, a felhasználói élmény javítására, valamint a hirdetések és konverziók mérésére.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Jogalap",

                    paragraphs: [
                        "A külső analitikai és hirdetési szolgáltatások, valamint a STRIKE saját belső kampány- és konverziómérésének jogalapja az érintett GDPR 6. cikk (1) bekezdés a) pontja szerinti önkéntes hozzájárulása.",
                        "Az analitikai adatkezelés és a belső kampánymérés kizárólag akkor indul el, ha az érintett az analitikai célú adatkezeléshez hozzájárult. A marketingcélú szolgáltatások kizárólag akkor aktiválódnak, ha az érintett a marketingcélú adatkezeléshez is hozzájárult.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "A hozzájárulás önkéntessége",

                    paragraphs: [
                        "Az analitikai vagy marketingcélú hozzájárulás megtagadása nem korlátozza a weboldal alapvető használatát, a regisztrációt, a foglalást, a jegyvásárlást vagy a STRIKE szolgáltatásainak igénybevételét.",
                        "Az érintett a hozzájárulását a sütibeállításoknál bármikor módosíthatja vagy visszavonhatja. A hozzájárulás visszavonása nem érinti a visszavonást megelőző adatkezelés jogszerűségét.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Megőrzési idő",

                    paragraphs: [
                        "A böngészőoldali analitikai és marketingelemek megőrzési idejét a sütik és böngészőoldali adattárolás fejezete tartalmazza.",
                        "A STRIKE saját rendszerében a technikai vendégazonosítóhoz kapcsolt referrer- és UTM-adatokat a hozzájárulás visszavonásáig, de legfeljebb az adat rögzítésétől számított 1 évig kezeli. Ezt követően az adatokat törli vagy visszafordíthatatlanul anonimizálja.",
                    ],
                },
            ],
        },
        {
            id:
                "cookies-and-browser-storage",

            title:
                "Sütik és böngészőoldali adattárolás",

            entries: [
                "A sütik a böngészőben elhelyezett kis adatfájlok. A weboldal emellett sessionStorage vagy más böngészőoldali adattárolást is használhat. A feltétlenül szükséges elemek a weboldal, a kosár, a foglalás, a fizetés és a hozzájárulási beállítások működését biztosítják. Az analitikai és marketingelemek csak a megfelelő hozzájárulás után aktiválódnak.",
                {
                    type:
                        "table",

                    title:
                        "Feltétlenül szükséges sütik",

                    rows: [
                        {
                            name:
                                "guestJwt",

                            type:
                                "süti",

                            purpose:
                                "A vendégmunkamenet, a vendégkosár és a vendégként indított foglalási folyamat biztonságos azonosítása, továbbá a visszaélések megelőzésének és kivizsgálásának támogatása. Az elem a szükséges vendégfolyamat első szerverkapcsolatakor jön létre, és analitikai vagy marketinghozzájárulás nélkül sem tartalmaz referrer- vagy UTM-adatot.",

                            duration:
                                "180 nap",
                        },
                        {
                            name:
                                "__stripe_mid",

                            type:
                                "Stripe-süti",

                            purpose:
                                "Fizetési biztonság és csalásmegelőzés.",

                            duration:
                                "180 nap",
                        },
                        {
                            name:
                                "__stripe_sid",

                            type:
                                "Stripe-süti",

                            purpose:
                                "A fizetési munkamenet biztonsága és csalásmegelőzés.",

                            duration:
                                "körülbelül 30 perc",
                        },
                    ],
                },
                {
                    type:
                        "table",

                    title:
                        "Analitikai és marketingcélú sütik",

                    rows: [
                        {
                            name:
                                "_ga",

                            type:
                                "Google Analytics-süti",

                            purpose:
                                "Látogatók és weboldalhasználat statisztikai mérése.",

                            duration:
                                "180 nap",
                        },
                        {
                            name:
                                "_ga_8PFEXZMBR6",

                            type:
                                "Google Analytics-süti",

                            purpose:
                                "A Google Analytics munkamenet- és mérési állapotának kezelése.",

                            duration:
                                "180 nap",
                        },
                        {
                            name:
                                "_gcl_au és más Google Ads-elemek",

                            type:
                                "Google Ads-süti",

                            purpose:
                                "Hirdetési konverziók és kampányeredmények mérése.",

                            duration:
                                "a szolgáltató beállításától függően, jellemzően legfeljebb 90 nap",
                        },
                        {
                            name:
                                "_fbp és más Meta-elemek",

                            type:
                                "Meta-süti",

                            purpose:
                                "Hirdetések eredményességének és konverzióinak mérése.",

                            duration:
                                "a szolgáltató beállításától függően, jellemzően legfeljebb 90 nap",
                        },
                        {
                            name:
                                "_clck, _clsk és más Clarity-elemek",

                            type:
                                "Microsoft Clarity-süti",

                            purpose:
                                "A weboldal használatának és felhasználói élményének elemzése.",

                            duration:
                                "az adott elemtől függően a munkamenet végéig vagy legfeljebb 1 év",
                        },
                    ],
                },
                {
                    type:
                        "table",

                    title:
                        "sessionStorage elemek",

                    rows: [
                        {
                            name:
                                "cookieBannerDone",

                            type:
                                "sessionStorage",

                            purpose:
                                "A sütibeállítási felület aktuális munkameneten belüli állapota.",

                            duration:
                                "a böngészőlap bezárásáig",
                        },
                        {
                            name:
                                "cookieConsent",

                            type:
                                "sessionStorage",

                            purpose:
                                "A szükséges, analitikai és marketingcélú hozzájárulási választások kezelése az aktuális munkamenetben.",

                            duration:
                                "a böngészőlap bezárásáig",
                        },
                        {
                            name:
                                "guestName",

                            type:
                                "sessionStorage",

                            purpose:
                                "Véletlenszerű technikai vendégazonosító biztosítása a munkamenet megkülönböztetéséhez, a visszaélések kivizsgálásához, valamint ahhoz, hogy a vendég hozzáférési vagy törlési kérelem esetén hivatkozhasson a saját technikai azonosítójára. Az azonosító önmagában nem tartalmaz nevet, e-mail-címet vagy más közvetlen személyazonosító adatot.",

                            duration:
                                "a böngészőlap bezárásáig",
                        },
                        {
                            name:
                                "strikePaymentSummary",

                            type:
                                "sessionStorage",

                            purpose:
                                "A foglalási és fizetési összesítő megjelenítése.",

                            duration:
                                "a böngészőlap bezárásáig",
                        },
                        {
                            name:
                                "visitorArrival",

                            type:
                                "sessionStorage",

                            purpose:
                                "A user agent és az érkezés időpontjának ideiglenes kezelése a visszaélések megelőzése, felismerése és kivizsgálása érdekében. Analitikai hozzájárulás hiányában az elem nem tartalmaz referrer- vagy UTM-adatot. Az analitikai hozzájárulás megadása után az elem a STRIKE saját belső kampány- és konverzióméréséhez szükséges referrer- és UTM-adatokkal egészülhet ki.",

                            duration:
                                "a böngészőlap bezárásáig vagy a hozzájárulás visszavonásáig",
                        },
                    ],
                },

                "A külső szolgáltatók a szolgáltatásaik változásával további technikai elemeket is alkalmazhatnak. A sütik aktuális listája a böngésző fejlesztői eszközeiben is megtekinthető. A felhasználó a hozzájárulását a weboldal sütibeállításaiban bármikor módosíthatja.",
            ],
        },
        {
            id:
                "technical-and-security-logs",

            title:
                "Technikai, biztonsági és szervernaplók",

            entries: [
                {
                    type:
                        "block",

                    title:
                        "Kezelt adatok",

                    paragraphs: [
                        "Véletlenszerű technikai vendégazonosító, IP-cím, user agent, az érkezés és a kérés időpontja, meglátogatott útvonal, HTTP-metódus, HTTP-állapot, böngésző- és eszköztípusra vonatkozó technikai adatok, biztonsági események, bejelentkezési és rendszeresemények, valamint a hibák és visszaélések kivizsgálásához szükséges technikai információk.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Az adatkezelés célja",

                    paragraphs: [
                        "Az informatikai rendszer, a felhasználói fiókok, a vendégkosarak, a foglalások és a fizetési folyamatok biztonságának fenntartása, továbbá az automatizált támadások, jogosulatlan hozzáférések, csalások és egyéb visszaélések megelőzése, felismerése és kivizsgálása.",
                        "A véletlenszerű technikai vendégazonosító lehetővé teszi, hogy a vendég hozzáférési, törlési vagy visszaélés-bejelentési kérelem esetén hivatkozhasson a saját technikai munkamenetére.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Jogalap",

                    paragraphs: [
                        "Az adatkezelés jogalapja a GDPR 6. cikk (1) bekezdés f) pontja szerinti jogos érdek. Az Adatkezelő jogos érdeke a szolgáltatás biztonságos működtetése, az informatikai rendszerek és a felhasználók védelme, valamint a visszaélésekből eredő károk megelőzése.",
                        "A jogos érdek alapján kezelt biztonsági naplóadatokat az Adatkezelő nem használja webanalitikai, kampánymérési, reklámozási vagy profilalkotási célra. Az analitikai célból kezelt referrer- és UTM-adatok ettől elkülönülnek, és kizárólag megfelelő hozzájárulás alapján kezelhetők.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Megőrzési idő",

                    paragraphs: [
                        "A technikai és biztonsági naplóadatokat az Adatkezelő legfeljebb 1 évig őrzi meg. Amennyiben egy adat konkrét biztonsági incidens, csalás, visszaélés vagy jogi eljárás kivizsgálásához szükséges, az érintett naplórészlet az ügy lezárásáig, illetve a kapcsolódó jogi igény elévüléséig elkülönítetten megőrizhető.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Tiltakozáshoz való jog",

                    paragraphs: [
                        "Az érintett jogosult a saját helyzetével kapcsolatos okból tiltakozni a jogos érdeken alapuló adatkezelés ellen az info@strike.hu címen. Az Adatkezelő a tiltakozás esetén az adatkezelést megszünteti, kivéve, ha bizonyítja, hogy az adatkezelést olyan kényszerítő erejű jogos okok indokolják, amelyek elsőbbséget élveznek az érintett érdekeivel, jogaival és szabadságaival szemben, vagy amelyek jogi igények előterjesztéséhez, érvényesítéséhez vagy védelméhez kapcsolódnak.",
                    ],
                },
            ],
        },
        {
            id:
                "guest-wifi",

            title:
                "Vendég Wi-Fi",

            entries: [
                "A STRIKE helyszínén saját MikroTik eszközzel működtetett vendég Wi-Fi érhető el.",
                {
                    type:
                        "block",

                    title:
                        "Kezelt adatok",

                    paragraphs: [
                        "A csatlakozó eszköz IP-címe, MAC-címe, eszközneve, valamint a csatlakozás és leválasztás időpontja.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Cél és jogalap",

                    paragraphs: [
                        "A hálózat biztonságának fenntartása, a visszaélések megelőzése, felismerése és kivizsgálása. A jogalap a GDPR 6. cikk (1) bekezdés f) pontja szerinti jogos érdek.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Megőrzési idő",

                    paragraphs: [
                        "A naplóadatokat a STRIKE legfeljebb 1 évig őrzi meg. Konkrét visszaélés vagy jogi eljárás esetén az érintett naplórészlet az eljárás lezárásáig elkülönítetten megőrizhető.",
                    ],
                },
            ],
        },
        {
            id:
                "cctv",

            title:
                "Kamerás megfigyelés",

            entries: [
                "A STRIKE helyszínén vagyonvédelmi, személybiztonsági, baleset-megelőzési és incidenskivizsgálási célból képfelvételt rögzítő kamerarendszer működik. A kamerák hangot nem rögzíthetnek, és látóterük csak a cél eléréséhez feltétlenül szükséges területre irányulhat.",
                {
                    type:
                        "block",

                    title:
                        "Kezelt adatok",

                    paragraphs: [
                        "Az érintett képmása, mozgása, a helyszínen tanúsított, felvételen látható magatartása, valamint a felvétel helye és időpontja.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Jogalap",

                    paragraphs: [
                        "Az adatkezelés jogalapja a GDPR 6. cikk (1) bekezdés f) pontja szerinti jogos érdek. Az Adatkezelő jogos érdeke a személy- és vagyonbiztonság fenntartása, a balesetek, károkozások és más biztonsági események megelőzése, felismerése és kivizsgálása.",
                        "A kamerák elhelyezkedéséről, látóteréről, céljáról, a felvételek megőrzési idejéről és a hozzáférésre jogosultakról külön kamerás tájékoztató érhető el a helyszínen.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Megőrzési idő és hozzáférés",

                    paragraphs: [
                        "A felvételek automatikusan, legfeljebb 3 nap elteltével törlődnek, ha azok felhasználására nem kerül sor. Incidens, baleset, károkozás, visszaélés vagy hatósági megkeresés esetén a szükséges felvétel elkülöníthető, és az ügy jogerős lezárásáig, illetve a jogi igény elévüléséig megőrizhető. A felvételekhez kizárólag az erre feljogosított személyek férhetnek hozzá dokumentált módon.",
                    ],
                },
            ],
        },
        {
            id:
                "photographs-and-videos",

            title:
                "Fénykép-, videó- és rendezvényfelvételek",

            entries: [
                "A STRIKE egyes eseményeken előzetes, jól látható tájékoztatás mellett fénykép- vagy videófelvételeket készíthet. A felvételek a STRIKE weboldalán, közösségi médiafelületein, hirdetéseiben és egyéb marketinganyagaiban jelenhetnek meg.",
                "Egy személyt kiemelten és felismerhetően ábrázoló felvétel elkészítésének és marketingcélú felhasználásának jogalapja az érintett önkéntes hozzájárulása. A tömegfelvételre a Polgári Törvénykönyv képmásra vonatkozó rendelkezései alkalmazandók, azonban az Adatkezelő ebben az esetben is előzetes tájékoztatást ad a felvételkészítésről.",
                "Kiskorú felismerhető szerepeltetésére csak a vonatkozó szabályok szerinti törvényes képviselői, illetve szükség szerint a kiskorú által is megadott hozzájárulással kerülhet sor.",
                "A hozzájárulás bármikor visszavonható az info@strike.hu címen. A felvételeket a STRIKE a hozzájárulás visszavonásáig, de legfeljebb 5 évig kezeli. A visszavonást követően a STRIKE a saját kezelésében lévő felvételt törli, illetve a további felhasználását megszünteti, kivéve, ha más jogalap vagy jogi kötelezettség alkalmazandó.",
            ],
        },
        {
            id:
                "prize-draws",

            title:
                "Nyereményjátékok",

            entries: [
                "A STRIKE időszakosan nyereményjátékot hirdethet. Az egyes nyereményjátékokhoz külön játékszabályzat és rövid adatkezelési tájékoztatás készül, amely meghatározza a kezelt adatok körét, a részvétel feltételeit, a nyertes kiválasztásának és közzétételének módját, az adatkezelés jogalapját, valamint a megőrzési időt.",
                "A nyereményjátékban való részvétel nem köthető kötelező hírlevél-feliratkozáshoz. Marketingüzenet csak külön, önkéntes hozzájárulás alapján küldhető.",
            ],
        },
        {
            id:
                "game-results",

            title:
                "Játékoseredmények megjelenítése",

            entries: [
                "A játékeredmények a helyszínen található televíziós eredménykijelzőn jelenhetnek meg. A rendszer nem használ valódi játékosnevet, hanem véletlenszerű vagy általános megnevezést, például „1. játékos” vagy „2. játékos” jelenít meg.",
                "Amennyiben az eredmény az érintetthez sem közvetlenül, sem közvetetten nem kapcsolható, az nem minősül személyes adatnak. A STRIKE a jövőben csak külön tájékoztatás és megfelelő jogalap mellett kapcsolhat eredményt azonosítható játékoshoz.",
            ],
        },
        {
            id:
                "processors-and-recipients",

            title:
                "Adatfeldolgozók és címzettek",

            entries: [
                "Az Adatkezelő a szolgáltatás működtetése során különösen az alábbi adatfeldolgozókat és szolgáltatókat veszi igénybe:",
                {
                    type:
                        "block",

                    title:
                        "Rendszeres Kft.",

                    paragraphs: [
                        "Székhely: 2161 Csomád, Kossuth Lajos út 47.",
                        "Cégjegyzékszám: 13-09-229423",
                        "Adószám: 22740175-2-13",
                        "Feladata: informatikai üzemeltetés, tárhely-, adatbázis- és levelezési infrastruktúra, biztonsági mentés és technikai támogatás. Az infrastruktúra németországi szervereken működik.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Cloudflare",

                    paragraphs: [
                        "Tartalomtovábbítás, DNS, weboldalbiztonság, támadás- és visszaélés-megelőzés. A szolgáltatás használata során technikai adatok, különösen IP-címek kerülhetnek kezelésre.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Stripe",

                    paragraphs: [
                        "Online bankkártyás fizetés, tranzakciókezelés, fizetési biztonság és csalásmegelőzés.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Billingo",

                    paragraphs: [
                        "Elektronikus számlák kiállítása, tárolása és kézbesítése.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "OTP Bank",

                    paragraphs: [
                        "A STRIKE bankszámlájának vezetése és a banki átutalások teljesítése. Banki átutalás esetén a pénzforgalmi szolgáltatás működéséből adódóan az átutaló neve, bankszámlaszáma, az átutalt összeg, a tranzakció időpontja és közleménye a banki tranzakció adatai között megjelenhet.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Google, Meta és Microsoft",

                    paragraphs: [
                        "Hozzájárulás esetén analitikai, konverziómérési, hirdetési és felhasználóiélmény-elemzési szolgáltatások.",
                    ],
                },
                "A hírlevelek kiküldését a STRIKE saját, a fent megjelölt szerverinfrastruktúrán működő rendszere végzi.",
                "Az Adatkezelő az adatokat hatóság, bíróság vagy más jogosult szerv részére jogszabályi kötelezettség alapján továbbíthatja.",
            ],
        },
        {
            id:
                "international-transfers",

            title:
                "Nemzetközi adattovábbítás",

            entries: [
                "A fő web- és adatbázis-infrastruktúra az Európai Unióban, Németországban működik. Egyes globális szolgáltatók, különösen a Cloudflare, Google, Meta, Microsoft és Stripe szolgáltatásainak használata során személyes adatok az Európai Gazdasági Térségen kívül is kezelésre kerülhetnek.",
                "Ilyen továbbításra csak a GDPR V. fejezetének megfelelő garanciák mellett, például megfelelőségi határozat, érvényes adattovábbítási keretrendszer vagy az Európai Bizottság által elfogadott általános szerződési feltételek alkalmazásával kerülhet sor. A részletes garanciák az érintett szolgáltató adatvédelmi tájékoztatójában ismerhetők meg.",
            ],
        },
        {
            id:
                "backups-and-security",

            title:
                "Biztonsági mentések és adatbiztonság",

            entries: [
                "A STRIKE a rendszer és az adatok rendelkezésre állásának biztosítása érdekében elkülönített szerveren biztonsági mentéseket készít. A személyes adatokat tartalmazó mentések nem kerülnek magáncélú számítógépen tárolásra.",
                "A mentésekhez való hozzáférés korlátozott és védett. A mentési rendszer a mentéseket automatikus rotációval legfeljebb 90 napig őrzi meg. A mentések rendeltetése kizárólag a rendszer helyreállítása, azokat a STRIKE nem használja új adatkezelési célra.",
                "Törlési kérelem vagy megőrzési idő lejárta esetén az adat az aktív rendszerből törlődik. A rotációs mentésben ideiglenesen megmaradó adat a mentés rendes felülírásakor törlődik, és rendszer-helyreállítás esetén a törlési műveleteket ismét alkalmazni kell.",
            ],
        },
        {
            id:
                "data-subject-rights",

            title:
                "Az érintett jogai",

            entries: [
                "Az érintett az info@strike.hu címen kérhet tájékoztatást személyes adatainak kezeléséről, hozzáférést kérhet az adatokhoz és azok másolatához, továbbá kérheti a pontatlan adatok helyesbítését.",
                "Az alkalmazandó feltételek fennállása esetén az érintett kérheti személyes adatainak törlését, kezelésük korlátozását, gyakorolhatja az adathordozhatósághoz való jogát, és tiltakozhat a jogos érdeken alapuló adatkezelés ellen.",
                "Hozzájáruláson alapuló adatkezelésnél a hozzájárulás bármikor visszavonható. A visszavonás nem érinti az azt megelőző adatkezelés jogszerűségét.",
                "Az Adatkezelő a kérelmet indokolatlan késedelem nélkül, de legkésőbb annak beérkezésétől számított egy hónapon belül megválaszolja. A határidő a GDPR feltételei szerint további két hónappal meghosszabbítható.",
                "A jogok gyakorlása nem eredményezheti más személy jogainak és szabadságainak sérelmét, és nem érinti a kötelező jogszabályi adatmegőrzést.",
            ],
        },
        {
            id:
                "legal-remedies",

            title:
                "Jogorvoslat",

            entries: [
                "Amennyiben az érintett úgy véli, hogy a személyes adatainak kezelése sérti a vonatkozó jogszabályokat, panaszt tehet a Nemzeti Adatvédelmi és Információszabadság Hatóságnál.",
                {
                    type:
                        "details",

                    items: [
                        "Nemzeti Adatvédelmi és Információszabadság Hatóság",
                        "Székhely: 1055 Budapest, Falk Miksa utca 9–11.",
                        "Levelezési cím: 1363 Budapest, Pf. 9.",
                        "E-mail: ugyfelszolgalat@naih.hu",
                        "Weboldal: naih.hu",
                    ],
                },
                "Az érintett jogosult bírósághoz is fordulni. A pert választása szerint a lakóhelye vagy tartózkodási helye szerinti törvényszék előtt is megindíthatja.",
            ],
        },
        {
            id:
                "automated-decision-making",

            title:
                "Automatizált döntéshozatal és profilalkotás",

            entries: [
                "A STRIKE nem alkalmaz olyan kizárólag automatizált döntéshozatalt, amely az érintettre nézve joghatással járna vagy őt hasonlóképpen jelentős mértékben érintené.",
                "Hozzájárulás esetén az analitikai és hirdetési szolgáltatók a saját rendszereikben profilalkotást végezhetnek. Ennek részleteit az adott szolgáltató adatvédelmi tájékoztatója tartalmazza, a hozzájárulás pedig a sütibeállításokban visszavonható.",
            ],
        },
        {
            id:
                "notice-amendments",

            title:
                "A tájékoztató módosítása",

            entries: [
                "Az Adatkezelő jogosult a tájékoztatót a jogszabályok, a szolgáltatások vagy az adatkezelési folyamatok változása esetén módosítani. A mindenkor hatályos változat a strike.hu weboldalon érhető el.",
                "Lényeges változás esetén az Adatkezelő a felhasználókat a weboldalon, illetve indokolt esetben e-mailben tájékoztatja.",
                {
                    type:
                        "highlight",

                    items: [
                        `Hatályos: ${privacyEffectiveDateHu}`,
                    ],
                },
            ],
        },
    ],
};

export default privacyContentHu;